import React from 'react';
import FormGroup from '~/components/form/form-group';

export const OwnerForm = ({ state, fieldActions, readonly = false }) => {
    return (
        <React.Fragment>
            <FormGroup
                label="First"
                readOnly={readonly}
                groupClassName="col-span-2"
                path='ownerFirstName'
                value={state.values.ownerFirstName}
                error={state.errors.ownerFirstName}
                {...fieldActions}
            />
            <FormGroup
                label="Middle"
                readOnly={readonly}
                groupClassName="col-span-2"
                path='ownerMiddleName'
                value={state.values.ownerMiddleName}
                error={state.errors.ownerMiddleName}
                {...fieldActions}
            />
            <FormGroup
                label="Last"
                readOnly={readonly}
                groupClassName="col-span-2"
                path='ownerLastName'
                value={state.values.ownerLastName}
                error={state.errors.ownerLastName}
                {...fieldActions}
            />
            <FormGroup
                label="Suffix"
                readOnly={readonly}
                groupClassName="col-span-1"
                path='ownerSuffix'
                value={state.values.ownerSuffix}
                error={state.errors.ownerSuffix}
                {...fieldActions}
            />
        </React.Fragment>
    );
};

export default OwnerForm;